import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContract } from '../contexts/ContractContext';
import { useWallet } from '../contexts/WalletContext';
import { useNetwork } from '../contexts/NetworkContext';
// import { validateYourContract } from '../contracts/contract';
import './ContractAddressInput.css';

const ContractAddressInput: React.FC = () => {
  const { isValidAddress, contractAddress: urlContractAddress } = useContract();
  const { provider } = useWallet();
  const { currentNetwork } = useNetwork();
  const navigate = useNavigate();
  const [address, setAddress] = useState('');
  const [error, setError] = useState('');
  const [isValidating, setIsValidating] = useState(false);

  // Initialize address from URL if present
  useEffect(() => {
    if (urlContractAddress && !address) {
      setAddress(urlContractAddress);
    }
  }, [urlContractAddress, address]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!address.trim()) {
      setError('Please enter a contract address');
      return;
    }

    if (!isValidAddress(address.trim())) {
      setError('Please enter a valid Ethereum address');
      return;
    }

    if (!provider || !currentNetwork) {
      setError('Wallet not connected or network not selected');
      return;
    }

    setIsValidating(true);
    setError('');

    try {
      // TODO: Replace with your contract validation logic
      // const isValidContract = await validateYourContract(provider, address.trim());
      
      // Placeholder validation - check if it's a valid contract address
      const isValidContract = address.trim().length === 42 && address.startsWith('0x');
      
      if (isValidContract) {
        // Navigate to homepage with the contract address and chain ID in URL
        const searchParams = new URLSearchParams();
        searchParams.set('chainId', currentNetwork.chainId.toString());
        searchParams.set('contractAddress', address.trim());
        navigate(`/?${searchParams.toString()}`);
      } else {
        setError('Please enter a valid contract address.');
      }
    } catch (err) {
      setError('Failed to validate contract. Please check your network connection and try again.');
      console.error('Contract validation error:', err);
    } finally {
      setIsValidating(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAddress(e.target.value);
    if (error) setError(''); // Clear error when user starts typing
  };

  return (
    <div className="contract-address-section">
      <div className="contract-address-card">
        <h2>Enter Contract Address</h2>
        <p className="contract-description">
        Please enter the address of the TrustLine-protected smart contract you want to interact with.
        </p>
        
        <form onSubmit={handleSubmit} className="contract-form">
          <div className="form-group">
            <label htmlFor="contract-address">Contract Address:</label>
            <input
              id="contract-address"
              type="text"
              value={address}
              onChange={handleChange}
              placeholder="0x..."
              className={error ? 'error' : ''}
              autoFocus
            />
            {error && <div className="error">{error}</div>}
          </div>
          
          <button type="submit" className="submit-btn" disabled={isValidating}>
            {isValidating ? 'Validating Contract...' : 'Connect to Contract'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContractAddressInput;
